import React from "react";

interface NewInProps {
  size?: "default" | "small";
}

const NewIn: React.FC<NewInProps> = ({ size = "default" }) => {
  return (
    <>
      <div className={`new-in-tag ${size}`}>New</div>
      <style jsx>{`
        .new-in-tag {
          width: 38px;
          padding: 0 6px;
          height: 20px;
          background: #191919;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;

          font-size: 13px;
          font-style: normal;
          font-weight: 700;
          line-height: 20px;

          &.small {
            width: 31px;
            font-size: 10px;
            height: 16px;
            line-height: 16px;
          }
        }
      `}</style>
    </>
  );
};

export default NewIn;
